/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdIdCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdIdProps,
  PutDecisioningStudioAgentsAppGroupIdIdResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdId = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdIdCacheKeys,
  ({
    appGroupId,
    id,
    frequency_cap,
  }: PutDecisioningStudioAgentsAppGroupIdIdProps): Promise<PutDecisioningStudioAgentsAppGroupIdIdResult> => {
    return fetch(`/decisioning_studio_agents/${appGroupId}/${id}`, "PUT", {
      dsa: { frequency_cap },
    });
  }
);
